/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _objectWithoutProperties } from '../../_chunks/dep-92728dc5.js';
import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React, { forwardRef, useRef, Children, isValidElement, cloneElement } from 'react';
import classNames from 'classnames';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import { getSelectValueArr } from '../util/helper.js';
import useConfig from '../../hooks/useConfig.js';
import usePanelVirtualScroll from '../hooks/usePanelVirtualScroll.js';
import Option from './Option.js';
import '../../_chunks/dep-2acfafca.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-337b4140.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-33ffecad.js';
import './OptionGroup.js';
import '../defaultProps.js';
import '../../_chunks/dep-0e15088f.js';
import '../../_chunks/dep-6c5254c6.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_util/easing.js';
import '../../hooks/useVirtualScroll.js';
import '../../hooks/useResizeObserver.js';

var _excluded = ["value", "label", "disabled", "content", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PopupContent = /*#__PURE__*/forwardRef(function (props, ref) {
  var value = props.value,
    size = props.size,
    max = props.max,
    multiple = props.multiple,
    showPopup = props.showPopup,
    setShowPopup = props.setShowPopup,
    empty = props.empty,
    loadingText = props.loadingText,
    loading = props.loading,
    valueType = props.valueType,
    children = props.children,
    keys = props.keys,
    panelTopContent = props.panelTopContent,
    panelBottomContent = props.panelBottomContent,
    onChange = props.onChange,
    onCheckAllChange = props.onCheckAllChange,
    propsOptions = props.options,
    propsScroll = props.scroll;
  var _useLocaleReceiver = useLocaleReceiver("select"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var emptyText = t(local.empty);
  var popupContentRef = useRef(null);
  popupContentRef.current = props.getPopupInstance();
  var _usePanelVirtualScrol = usePanelVirtualScroll({
      popupContentRef: popupContentRef,
      scroll: propsScroll,
      options: propsOptions
    }),
    visibleData = _usePanelVirtualScrol.visibleData,
    handleRowMounted = _usePanelVirtualScrol.handleRowMounted,
    isVirtual = _usePanelVirtualScrol.isVirtual,
    panelStyle = _usePanelVirtualScrol.panelStyle,
    cursorStyle = _usePanelVirtualScrol.cursorStyle;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  if (!children && !propsOptions) return null;
  var onSelect = function onSelect(selectedValue, _ref) {
    var label = _ref.label,
      selected = _ref.selected,
      event = _ref.event,
      restData = _ref.restData;
    var isValObj = valueType === "object";
    var objVal = {};
    if (isValObj) {
      objVal = _objectSpread({}, restData);
      if (!(keys !== null && keys !== void 0 && keys.label)) {
        Object.assign(objVal, {
          label: label
        });
      }
      if (!(keys !== null && keys !== void 0 && keys.value)) {
        Object.assign(objVal, {
          value: selectedValue
        });
      }
    }
    if (!Object.keys(objVal).length) {
      var _Object$assign;
      Object.assign(objVal, (_Object$assign = {}, _defineProperty(_Object$assign, (keys === null || keys === void 0 ? void 0 : keys.label) || "label", label), _defineProperty(_Object$assign, (keys === null || keys === void 0 ? void 0 : keys.value) || "value", selectedValue), _Object$assign));
    }
    if (multiple) {
      var values = getSelectValueArr(value, selectedValue, selected, valueType, keys, objVal);
      onChange(values, {
        label: label,
        e: event,
        trigger: "check"
      });
    } else {
      var selectVal = valueType === "object" ? objVal : selectedValue;
      onChange(selectVal, {
        label: label,
        e: event,
        trigger: "check"
      });
      setShowPopup(!showPopup);
    }
  };
  var childrenWithProps = Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      var addedProps = {
        size: size,
        max: max,
        multiple: multiple,
        selectedValue: value,
        onSelect: onSelect
      };
      return /*#__PURE__*/cloneElement(child, _objectSpread({}, addedProps));
    }
    return child;
  });
  var renderOptions = function renderOptions(options) {
    if (options) {
      var uniqueOptions = [];
      options.forEach(function (option) {
        var index = uniqueOptions.findIndex(function (item) {
          return item.label === option.label && item.value === option.value;
        });
        if (index === -1) {
          uniqueOptions.push(option);
        }
      });
      var selectableOption = uniqueOptions.filter(function (v) {
        return !v.disabled && !v.checkAll;
      });
      return /* @__PURE__ */React.createElement("ul", {
        className: "".concat(classPrefix, "-select__list")
      }, uniqueOptions.map(function (_ref2, index) {
        var _props$scroll, _props$scroll2;
        var optionValue = _ref2.value,
          label = _ref2.label,
          disabled = _ref2.disabled,
          content = _ref2.content,
          children2 = _ref2.children,
          restData = _objectWithoutProperties(_ref2, _excluded);
        return /* @__PURE__ */React.createElement(Option, _objectSpread(_objectSpread({
          key: index,
          max: max,
          label: label,
          value: optionValue,
          onSelect: onSelect,
          selectedValue: value,
          optionLength: selectableOption.length,
          multiple: multiple,
          size: size,
          disabled: disabled,
          restData: restData,
          keys: keys,
          content: content,
          onCheckAllChange: onCheckAllChange,
          onRowMounted: handleRowMounted
        }, isVirtual ? {
          isVirtual: isVirtual,
          bufferSize: (_props$scroll = props.scroll) === null || _props$scroll === void 0 ? void 0 : _props$scroll.bufferSize,
          scrollType: (_props$scroll2 = props.scroll) === null || _props$scroll2 === void 0 ? void 0 : _props$scroll2.type
        } : {}), restData), children2);
      }));
    }
    return /* @__PURE__ */React.createElement("ul", {
      className: "".concat(classPrefix, "-select__list")
    }, childrenWithProps);
  };
  var isEmpty = Array.isArray(childrenWithProps) && !childrenWithProps.length || propsOptions && propsOptions.length === 0;
  var renderPanel = function renderPanel(renderedOptions, extraStyle) {
    var _classNames;
    return /* @__PURE__ */React.createElement("div", {
      ref: ref,
      className: classNames("".concat(classPrefix, "-select__dropdown-inner"), (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-select__dropdown-inner--size-s"), size === "small"), _defineProperty(_classNames, "".concat(classPrefix, "-select__dropdown-inner--size-l"), size === "large"), _defineProperty(_classNames, "".concat(classPrefix, "-select__dropdown-inner--size-m"), size === "medium"), _classNames)),
      style: extraStyle
    }, panelTopContent, loading && /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-select__loading-tips")
    }, loadingText), !loading && isEmpty && /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-select__empty")
    }, empty ? empty : /* @__PURE__ */React.createElement("p", null, emptyText)), !loading && !isEmpty && renderOptions(renderedOptions), panelBottomContent);
  };
  if (isVirtual) {
    return /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement("div", {
      style: cursorStyle
    }), renderPanel(visibleData, panelStyle));
  }
  return renderPanel(propsOptions);
});

export { PopupContent as default };
//# sourceMappingURL=PopupContent.js.map
